<div class="row text-center">
  <div class="col">
    <div class="mt-5">
      <h2>Success! Your Merchant Application submission has been received!</h2>
      <img src="/money.png" alt="Success" class="money img-fluid" />
      <p>You will be redirected to the LINQ Pay Portal in just a moment...</p>
    </div>
  </div>
</div>
